import axios from 'axios';
import { USER_LOGIN_URL } from '../constant/apiConstants.js';

/* ------------------------------------------------------------------
 * Session storage keys
 * ------------------------------------------------------------------ */
export const SESSION_KEYS = {
  USER: 'user',
  TOKEN: 'token',
  STORE_CONFIG: 'storeConfig',
};

/* ------------------------------------------------------------------
 * Session storage helpers
 * ------------------------------------------------------------------ */
export const saveSession = ({ user, token, storeConfig }) => {
  try {
    if (user) sessionStorage.setItem(SESSION_KEYS.USER, JSON.stringify(user));
    if (token) sessionStorage.setItem(SESSION_KEYS.TOKEN, token);
    if (storeConfig) {
      sessionStorage.setItem(SESSION_KEYS.STORE_CONFIG, JSON.stringify(storeConfig));
    }
  } catch (e) {
    console.error('Failed to write session:', e);
  }
};

export const getSession = () => {
  try {
    const user = sessionStorage.getItem(SESSION_KEYS.USER);
    const storeConfig = sessionStorage.getItem(SESSION_KEYS.STORE_CONFIG);

    return {
      user: user ? JSON.parse(user) : null,
      token: sessionStorage.getItem(SESSION_KEYS.TOKEN) || null,
      storeConfig: storeConfig ? JSON.parse(storeConfig) : null,
    };
  } catch (e) {
    console.error('Failed to read session:', e);
    return { user: null, token: null, storeConfig: null };
  }
};

export const clearSession = () => {
  Object.values(SESSION_KEYS).forEach((key) => sessionStorage.removeItem(key));
};

export const isAuthenticated = () => Boolean(getSession().token);

/* ------------------------------------------------------------------
 * Login API
 * Returns a plain result object so the component never touches axios.
 *   success -> { success: true,  user, token, storeConfig }
 *   failure -> { success: false, message }
 * ------------------------------------------------------------------ */
export const loginUser = async (userId, password) => {
  try {
    const formData = new URLSearchParams();
    formData.append('userId', userId);
    formData.append('password', password);

    const response = await axios.post(USER_LOGIN_URL, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    if (response.data?.status === 'success') {
      const { user, token, storeConfig } = response.data.payload;

      // session handling lives here, not in the component
      saveSession({ user, token, storeConfig });

      return { success: true, user, token, storeConfig };
    }

    return {
      success: false,
      message: response.data?.payload?.message || 'Unable to login',
    };
  } catch (error) {
    if (error.response) {
      console.error('Login Error:', error.response.data);
      return {
        success: false,
        message:
          error.response.data?.message ||
          'Incorrect credentials. Please try again.',
      };
    }

    console.error('Network Error:', error);
    return {
      success: false,
      message: 'Something went wrong. Please try again later.',
    };
  }
};